// extracted by mini-css-extract-plugin
export default {"iosPopup":"IosPopup_iosPopup__EJbNy","iosPopup_visible":"IosPopup_iosPopup_visible__pldia"};